import { ModalFuncProps } from 'antd';

const DEFAULT_MODAL_OPTIONS: ModalFuncProps = {
  icon: <></>,
  width: 420,
  cancelButtonProps: { size: 'small' },
  okButtonProps: { size: 'small' },
};

export { DEFAULT_MODAL_OPTIONS };
